module.exports = __webpack_public_path__ + "img/place-keyword-desktop.febaf37a.png";